// @todo: Migrate to 'Toast' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {toast} from '@wandb/weave/common/components/elements/Toast';
import {TargetBlank} from '@wandb/weave/common/util/links';
// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import {clsx} from 'clsx';
import copyToClipboard from 'copy-to-clipboard';
import React, {useState} from 'react';

import {useViewer} from '../../state/viewer/hooks';
import DocUrls from '../../util/doc_urls';

const LOG_MODEL_CODE_SNIPPET = `# create a run and log a model artifact to it
with wandb.init(project="model-registration-example") as run:
    model_artifact = wandb.Artifact(
      name="my_model",
      type="model"
    )
    model_artifact.add_file("model_checkpt.pt")
    run.log_artifact(model_artifact)
    # logs the model version "my_model:v0"
`;

type QuickstartProps = {
  onCreateModel: () => void;
};
export const Quickstart = ({onCreateModel}: QuickstartProps) => {
  const viewer = useViewer();
  const isLoggedIn = !!viewer;

  const [isCreateModelExpanded, setIsCreateModelExpanded] = useState(false);
  const onToggleCreateModelExpanded = () => {
    setIsCreateModelExpanded(!isCreateModelExpanded);
  };

  // Log Model
  const [isLogModelExpanded, setIsLogModelExpanded] = useState(false);
  const onToggleLogModelExpanded = () => {
    setIsLogModelExpanded(!isLogModelExpanded);
  };

  const [isLogModelCodeExpanded, setIsLogModelCodeExpanded] = useState(false);
  const onToggleLogModelCodeExpanded = () => {
    setIsLogModelCodeExpanded(!isLogModelCodeExpanded);
  };

  const onCopyLogModelClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    copyToClipboard(LOG_MODEL_CODE_SNIPPET);
    toast('Copied to clipboard');
  };

  const [isHelpExpanded, setIsHelpExpanded] = useState(false);
  const onToggleHelpExpanded = () => {
    setIsHelpExpanded(!isHelpExpanded);
  };
  return (
    <Tailwind style={{width: '502px', borderRadius: '4px'}}>
      <div className="mt-24 flex flex-col justify-center rounded bg-moon-200 p-1">
        <span className="flex items-center gap-8 rounded bg-white px-16 py-12 text-xl leading-8">
          <Icon name="help-alt" />
          FAQs
        </span>
        <div className="h-px bg-moon-200" />
        <div
          className={clsx(
            `${isCreateModelExpanded ? 'rounded-t' : 'rounded'}`,
            'min-h-44 cursor-pointer bg-white p-10 hover:bg-moon-50'
          )}
          onClick={onToggleCreateModelExpanded}>
          <div className="flex items-center text-base/8 font-semibold">
            <Button
              variant="ghost"
              size="small"
              icon={isCreateModelExpanded ? 'chevron-down' : 'chevron-next'}
              onClick={onToggleCreateModelExpanded}
              className="mr-10"
            />
            How do I create my first registered model?
          </div>
        </div>
        {isCreateModelExpanded && (
          <>
            <div className="h-px bg-moon-200" />
            <div className="rounded-b bg-white px-40 py-16 text-base font-normal leading-5 text-moon-650">
              A registered model represents a model task or use-case your team
              is working on and houses a selection of staged model versions for
              this task.
              <div className="mt-16">
                Create a new registered model below to start bookmarking your
                best model versions to it.
              </div>
              {isLoggedIn && (
                <Button
                  className="create-collection-2 mt-16"
                  variant="secondary"
                  size="medium"
                  onClick={onCreateModel}>
                  Create collection
                </Button>
              )}
            </div>
          </>
        )}
        <div className="h-px bg-moon-200" />
        <div
          className={clsx(
            `${isLogModelExpanded ? 'rounded-t' : 'rounded'}`,
            'min-h-44 cursor-pointer bg-white p-10 hover:bg-moon-50'
          )}
          onClick={onToggleLogModelExpanded}>
          <div className="flex items-center text-base/8 font-semibold">
            <Button
              variant="ghost"
              size="small"
              icon={isLogModelExpanded ? 'chevron-down' : 'chevron-next'}
              onClick={onToggleLogModelExpanded}
              className="mr-10"
            />
            How do I log a model to an experiment?
          </div>
        </div>
        {isLogModelExpanded && (
          <>
            <div className="h-px bg-moon-200" />
            <div className="rounded-b bg-white px-40 py-16 text-base font-normal leading-5 text-moon-650">
              When you have a resulting model checkpoint that you are ready to
              save during your experiment run, use the code snippet below to log
              it to W&B.
              <div className="mt-16 flex flex-col rounded border border-solid border-moon-250 bg-moon-50 px-8">
                <div className="font-['Source Sans Pro'] flex flex-row items-center py-10 text-sm font-semibold">
                  <Button
                    variant="ghost"
                    size="small"
                    icon={
                      isLogModelCodeExpanded ? 'chevron-down' : 'chevron-next'
                    }
                    onClick={onToggleLogModelCodeExpanded}
                    className="mr-4"
                  />
                  Code snippet
                  <div className="ml-auto">
                    <Button
                      icon="copy"
                      variant="ghost"
                      size="small"
                      onClick={onCopyLogModelClick}
                      tooltip="Copy to clipboard">
                      Copy
                    </Button>
                  </div>
                </div>
                {isLogModelCodeExpanded && (
                  <div className="flex-auto whitespace-pre-wrap px-8 pb-8 font-['Source_Code_Pro'] text-xs leading-4">
                    {LOG_MODEL_CODE_SNIPPET}
                  </div>
                )}
              </div>
              <div className="mb-12 mt-16 text-base font-normal leading-5 text-moon-650">
                <TargetBlank href={DocUrls.artifacts}>
                  <span className="cursor-pointer font-semibold text-teal-650 hover:text-teal-500">
                    Learn more
                  </span>
                </TargetBlank>{' '}
                about logging and versioning experiment outputs as W&B Artifacts
              </div>
            </div>
          </>
        )}
        <div className="h-px bg-moon-200" />
        <div
          className={clsx(
            `${isHelpExpanded ? 'rounded-t' : 'rounded'}`,
            'min-h-44 cursor-pointer bg-white p-10 hover:bg-moon-50'
          )}
          onClick={onToggleHelpExpanded}>
          <div className="flex items-center text-base/8 font-semibold">
            <Button
              variant="ghost"
              size="small"
              icon={isHelpExpanded ? 'chevron-down' : 'chevron-next'}
              onClick={onToggleHelpExpanded}
              style={{marginRight: '10px'}}
            />
            What are the key features of the Model Registry?
          </div>
        </div>
        {isHelpExpanded && (
          <>
            <div className="h-px bg-moon-200" />
            <div className="rounded-b bg-white px-40 py-16 text-base font-normal leading-5 text-moon-650">
              Use the Model Registry to bookmark top-performing candidate models
              across an entity
              <ul className="my-16 list-disc">
                <li className="ml-24">
                  Set <span className="font-semibold">model stages</span> such
                  as "candidate" or "production"
                </li>
                <li className="ml-24">
                  <TargetBlank
                    href={
                      DocUrls.modelRegistry +
                      'walkthrough/#promote-a-model-version'
                    }>
                    <span className="cursor-pointer font-semibold text-teal-650 hover:text-teal-500">
                      Handoff models
                    </span>
                  </TargetBlank>{' '}
                  for consumption
                </li>
                <li className="ml-24">
                  Control{' '}
                  <TargetBlank href={DocUrls.modelRegistry + 'access_controls'}>
                    <span className="cursor-pointer font-semibold text-teal-650 hover:text-teal-500">
                      who can promote models
                    </span>
                  </TargetBlank>
                </li>
                <li className="ml-24">
                  Use{' '}
                  <TargetBlank href={DocUrls.automation}>
                    <span className="cursor-pointer font-semibold text-teal-650 hover:text-teal-500">
                      automations
                    </span>
                  </TargetBlank>{' '}
                  to manage Model CI/CD
                </li>
                <li className="ml-24">
                  Get{' '}
                  <TargetBlank href={DocUrls.modelRegistry + 'notifications'}>
                    <span className="cursor-pointer font-semibold text-teal-650 hover:text-teal-500">
                      alerts for registry events
                    </span>
                  </TargetBlank>{' '}
                  in Slack
                </li>
                <li className="ml-24">
                  Document <span className="font-semibold">model cards</span>{' '}
                  centrally
                </li>
              </ul>
              To learn more about these Model Registry features,{' '}
              <TargetBlank href={DocUrls.modelRegistry}>
                <span className="cursor-pointer font-semibold text-teal-650 hover:text-teal-500">
                  click here
                </span>
              </TargetBlank>
              .
            </div>
          </>
        )}
      </div>
    </Tailwind>
  );
};
